import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";


export default function HomeCruisePackageDeals() {
    const cruiseDeals = [
        {
            img: "south america.jpeg",
            title: "Oceanian Cruises",
            link: "https://www.kqzyfj.com/click-8265264-15731470"
        },
        {
            img: "d20cr0y5lovqgrjaoosj.jpeg",
            title: "Pacific Coastal Cruise",
            link: "https://www.anrdoezrs.net/click-8265264-15731471"
        },
        {
            img: "Europe_Hero_0.jpg",
            title: "Europe Cruises",
            link: "https://www.kqzyfj.com/click-8265264-13096760"
        },
        {
            img: "eastern mediterrnean.jpg",
            title: "Eastern Mediterranean Cruises",
            link: "https://www.kqzyfj.com/click-8265264-15731473"
        },
        {
            img: "oceania-cruises-marina1.jpg",
            title: "Oceania Cruises",
            link: "https://www.kqzyfj.com/click-8265264-15535742"
        },
        {
            img: "world cruise.webp",
            title: "Uniworld River Cruises",
            link: "https://www.tkqlhce.com/click-8265264-15535758"
        },
        {
            img: "Panama_Canal-HERO_0.jpg",
            title: "Panama Canal Cruises",
            link: "https://www.dpbolvw.net/click-8265264-13096769"
        },
        {
            img: "Mexico_Xelha_0.jpg",
            title: "Mexico Cruises",
            link: "https://www.dpbolvw.net/click-8265264-15534698"
        },
        {
            img: "Western_Mediterranean_Hero5_0.jpg",
            title: "Mediterranean Cruises",
            link: "https://www.tkqlhce.com/click-8265264-10929173"
        },
        {
            img: "Hawaii_Hero_0.jpg",
            title: "Hawaii Cruise",
            link: "https://www.dpbolvw.net/click-8265264-15533910"
        },
        {
            img: "Europe_Hero_0.jpg",
            title: "European Cruises",
            link: "https://www.dpbolvw.net/click-8265264-15534035"
        },
        {
            img: "Caribbean_Hero_0.jpg",
            title: "Caribbean Cruises",
            link: "https://www.anrdoezrs.net/click-8265264-15534704"
        },
        {
            img: "portland_Maine_lighthouse-hero_0.jpg",
            title: "Canada/New England Cruise",
            link: "https://www.tkqlhce.com/click-8265264-15533810"
        },
        {
            img: "horseshoe_beach-HERO_20_1_.jpg",
            title: "Bermuda Cruise",
            link: "https://www.kqzyfj.com/click-8265264-15534707"
        },
        {
            img: "Orient_Far_East_Hero3_0.jpg",
            title: "Asian Cruises",
            link: "https://www.anrdoezrs.net/click-8265264-10504131"
        },
        {
            img: "Bahamas_hero_0_1_0.jpg",
            title: "Bahamas Cruise",
            link: "https://www.kqzyfj.com/click-8265264-15534709"
        },
        {
            img: "Alaksa_Cruises_0.jpg",
            title: "Alaska Cruises",
            link: "https://www.kqzyfj.com/click-8265264-15533884"
        },
        {
            img: "last-minute-cruises.jpg",
            title: "Last-minute",
            link: "https://www.tkqlhce.com/click-8265264-10493749"
        },
        {
            img: "family-cruises.jpg",
            title: "Family Cruises",
            link: "https://www.kqzyfj.com/click-8265264-10678374"
        },
        {
            img: "honeymoon.png",
            title: "Honeymoon Cruises",
            link: "https://www.jdoqocy.com/click-8265264-10281267"
        },
        {
            img: "ncl_Bliss_Haven_Observ_Lounge_Dk17_Sofa_View.jpg",
            title: "Couple Cruises",
            link: "https://www.anrdoezrs.net/click-8265264-13312047"
        },
    ];

    return (
        <section className="section-equal-padding">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 mx-auto">
                        <div className="section-top-heading mb-3 mb-md-5 text-center" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <h2 className="mb-2 text-black">Cruise Package Deals</h2>
                            <p>Set sail on a dream cruise with stunning views and unmatched hospitality. Your next incredible adventure awaits!</p>
                        </div>
                    </div>

                </div>
                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    loop={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    navigation={true}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        992: { slidesPerView: 3 },
                        1400: { slidesPerView: 4 },
                    }}
                    className="excitement-swiper pb-70"
                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                >
                    {cruiseDeals.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="special-card-box cruise_package">
                                <figure>
                                    <img loading="lazy"
                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/${item.img}`}
                                        alt="Last-minute"
                                    />
                                </figure>
                                <div className="package-card-content">
                                    <a href={item.link}>{item.title}</a>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    )
}
